import React from 'react'

import './App.css'

// Imports
import Layout from './Pages/Layouts/MainLayout.jsx'

function App() {
  return <Layout />
}

export default App
